import { useRef, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from '@/components/ui/button';
import { RotateCcw, CheckCircle } from 'lucide-react';

const SignaturePad = ({ value, onChange, label = "Technician Signature" }) => {
  const sigPadRef = useRef(null);

  useEffect(() => {
    if (value && sigPadRef.current) {
      sigPadRef.current.fromDataURL(value);
    }
  }, [value]);

  const handleClear = () => {
    if (sigPadRef.current) {
      sigPadRef.current.clear();
      onChange('');
    }
  };

  const handleSave = () => {
    if (sigPadRef.current) {
      if (sigPadRef.current.isEmpty()) {
        return;
      }
      const dataURL = sigPadRef.current.toDataURL();
      onChange(dataURL);
    }
  };

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-gray-300">{label}</label>
      <div className="border border-gray-700 rounded-lg bg-white p-2">
        <SignatureCanvas
          ref={sigPadRef}
          canvasProps={{
            className: 'w-full h-32 rounded',
            style: { width: '100%', height: '128px' }
          }}
          backgroundColor="white"
          penColor="black"
          onEnd={handleSave}
        />
      </div>
      <div className="flex gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={handleClear}
          className="bg-gray-800 border-gray-700"
        >
          <RotateCcw className="w-4 h-4 mr-2" />
          Clear
        </Button>
        {value && (
          <div className="flex items-center text-green-500 text-sm">
            <CheckCircle className="w-4 h-4 mr-1" />
            Signature saved
          </div>
        )}
      </div>
    </div>
  );
};

export default SignaturePad;
